export default __webpack_public_path__ + "static/media/Microcef-50-ml-ban.ba226fba.jpg";